import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';

const buttonCommonCss = `
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	border-radius: 5px;
	cursor: pointer;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;

	& > span {
		width: 100%;
		text-align: center;
	}
`;

const Button = styled('button')`
	${buttonCommonCss}
	outline: none;
	max-width: 250px;
	border: 1px solid ${StyleColor.Blue300};
	height: 40px;
	color: ${StyleColor.Blue300};
	background-color: ${StyleColor.White};

	transition: border 0.2s, color 0.2s, background-color 0.2s;
	@media (hover: hover) {
		&:hover {
			border: 1px solid ${StyleColor.Blue300};
			color: ${StyleColor.White};
			background-color: ${StyleColor.Blue300};
		}
	}
`;

const BigButton = styled('button')`
	${buttonCommonCss}
	text-transform: uppercase;
	max-width: 430px;
	height: 50px;
	border: none;
	color: ${StyleColor.White};
	background-color: ${StyleColor.Blue300};
	opacity: 1;

	transition: opacity 0.2s;
	@media (hover: hover) {
		&:hover {
			opacity: 0.7;
		}
	}
`;

const NewButton = styled('button')`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
	border-radius: 9px;
	cursor: pointer;
	font-size: 18px;
	font-weight: 600;
	letter-spacing: 0.17px;
	border: none;
`;

export { Button, BigButton, NewButton };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Button/styles.ts